// Kompakte Status-Kachel (Handoff Selbstauskunft §2.1): Filter UND Zähler in einem Element.
// Glas, 92 px, Radius 22; Icon-Quadrat 30 (Farbe 13 % bzw. aktiv voll), Zahl 28/800 rechts, Label darunter.
import type { Icon } from '@phosphor-icons/react';

export interface StatusKachelProps {
  label: string;
  zahl: number;
  /** Statusfarbe (Token oder Hex) */
  farbe: string;
  icon: Icon;
  aktiv: boolean;
  onClick: () => void;
  tip?: string;
  /** großes, blasses Symbol rechts unten (Art-Widgets der Übergabe) */
  wasserzeichen?: boolean;
}

export function StatusKachel({ label, zahl, farbe, icon: I, aktiv, onClick, tip, wasserzeichen = false }: StatusKachelProps) {
  return (
    <button type="button" onClick={onClick} aria-pressed={aktiv} data-tip={tip} aria-label={`${label}: ${zahl}`}
      className="immo-glas immo-status-kachel relative flex min-w-0 flex-col justify-between overflow-hidden text-left"
      style={{ height: 92, padding: '12px 14px', borderRadius: 22, border: 'none', cursor: 'pointer', fontFamily: 'inherit', color: 'var(--ink)',
        boxShadow: aktiv ? `inset 0 0 0 2px ${farbe}, var(--glass-sh)` : undefined }}>
      {wasserzeichen && <I aria-hidden size={70} weight="fill" className="pointer-events-none absolute" style={{ right: -10, bottom: -14, color: farbe, opacity: 0.12 }} />}
      <span className="relative flex items-center justify-between" style={{ gap: 8 }}>
        <span aria-hidden className="inline-flex shrink-0 items-center justify-center" style={{ width: 30, height: 30, borderRadius: 10,
          background: aktiv ? farbe : `color-mix(in srgb, ${farbe} 13%, transparent)`, color: aktiv ? '#fff' : farbe }}>
          <I size={16} weight="fill" />
        </span>
        <span className="tabular-nums" style={{ fontSize: 28, fontWeight: 800, letterSpacing: '-0.03em', lineHeight: 1, color: aktiv ? farbe : 'var(--ink)' }}>{zahl}</span>
      </span>
      <span className="relative truncate" style={{ fontSize: 12.5, fontWeight: 700, color: aktiv ? 'var(--ink)' : 'var(--ink2)' }}>{label}</span>
    </button>
  );
}
